import React from 'react'
import LeadsBarChart from './LeadsBarChart'
import LeadsPieChart from './LeadsPieChart'
import { FiMessageSquare } from "react-icons/fi";

const LeadsCard = ({ bar_graph = true, pie_chart = false, bar_graph_data = [], heading, labels, postReactions }) => {

    const reactionsMetrics = [
        {

            name: "Like",
            value: postReactions?.likes?.count,
            percentage: postReactions?.likes?.percentage?.toFixed(2) ?? 0,
            backgroundColor: '#f97316'
        },

        {

            name: "Comment",
            value: postReactions?.comments?.count,
            percentage: postReactions?.comments?.percentage.toFixed(2) ?? 0,
            backgroundColor: '#fdba74'
        },
        {

            name: "Share",
            value: postReactions?.shares?.count,
            percentage: postReactions?.shares?.percentage.toFixed(2) ?? 0,
            backgroundColor: '#fb923c'
        },
        {

            name: "Save",
            value: postReactions?.save?.count,
            percentage: postReactions?.save?.percentage.toFixed(2) ?? 0,
            backgroundColor: '#fed7aa'
        }
    ]
    const values = [

        postReactions?.likes?.count,
        postReactions?.shares?.count,
        postReactions?.comments?.count,
        postReactions?.save?.count
    ]
    const pie_chart_labels = ['Like', 'Share', 'Comment', 'Save']
    const backgroundColors = ['#f97316', '#fb923c', '#fdba74', '#fed7aa']

    return (
        <div >
            <div className="row g-4">
                {bar_graph &&
                    <div className={`${pie_chart ? 'col-md-6' : 'col-md-12'} `}>
                        <div className="bar_chart_card w-100 px-4 py-1">
                            <div className='py-3 heading'>
                                <h5>{heading ?? "Clicks / Impressions / Share"}</h5>
                            </div>
                            <div className='py-3'>
                                <LeadsBarChart bar_graph_data={bar_graph_data} labels={labels} legend={true} />
                            </div>


                        </div>

                    </div>}

                {pie_chart &&
                    <div className="col-md-6 " >
                        <div className="pie_chart_card px-4 py-1">
                            <div className='py-3 heading'>
                                <h5>Post Reactions</h5>
                            </div>
                            <div className="row px-1">
                                <div className="col-md-5 py-3">
                                    <LeadsPieChart
                                        labels={pie_chart_labels}
                                        values={values}
                                        legend={true}
                                        backgroundColor={backgroundColors}

                                    />
                                </div>
                                <div className="col-md-7 ">
                                    <div className="container py-2">
                                        {/* <table class="table appliaction_convertion_rate_table">
                            <thead>
                                <tr>
                                    <th scope="col">Social Network</th>
                                    <th scope="col">Leads</th>
                                    <th scope="col">Applications</th>
                                    <th scope="col">%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row"> 
                                        <div className='d-flex align-items-center gap-1'>
                                            <div className='dot facebook'></div>
                                            <span> Facebook</span>
                                        </div>
                                       
                                    </th>
                                    <td>23</td>
                                    <td>14</td>
                                    <td>16.7%</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                    <div className='d-flex align-items-center gap-1'>
                                        <div className='dot instagram'></div>
                                        <span> Instagram</span>
                                    </div>
                                    </th>
                                    <td>14</td>
                                    <td>10</td>
                                    <td>20.2%</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                    <div className='d-flex align-items-center gap-1'>
                                        <div className='dot twitter'></div>
                                        <span> Twitter</span>
                                    </div>
                                    </th>
                                    <td>10</td>
                                    <td>5</td>
                                    <td>15.5%</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                    <div className='d-flex align-items-center gap-1'>
                                        <div className='dot linkedin'></div>
                                        <span> LinkedIn</span>
                                    </div>
                                    </th>
                                    <td>120</td>
                                    <td>10</td>
                                    <td>10%</td>
                                </tr>
                            </tbody>
                        </table> */}
                                        {/* <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom_container'> */}
                                            {/* <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom_container_heading'>
                                                <FiMessageSquare />
                                                <h4>Reactions Container</h4>
                                            </div> */}
                                            <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom_container_items_list d-flex flex-wrap flex-row'>
                                                {reactionsMetrics?.map((post) => {
                                                    return <div className='post_reaction_item' style={{width:'40%'}}>
                                                        <div className='post_reaction_item_top'>
                                                            <div className='post_reaction_header'>
                                                                <div className='post_reaction_item_dot'></div>
                                                                <span>{post?.name}</span>
                                                            </div>
                                                            <span>{post?.value}</span>
                                                        </div>
                                                        {/* progress bar */}
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{ width: post?.percentage + '%', backgroundColor: post?.backgroundColor ? post?.backgroundColor : '#f97316' }}></div>
                                                        </div>
                                                        <div className='post_reaction_item_bottom'>
                                                            <span>{post?.percentage}%</span>
                                                        </div>

                                                    </div>
                                                })}



                                            </div>

                                        {/* </div> */}
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>}
            </div>
        </div>
    )
}

export default LeadsCard